import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component'
import { NumberCardsComponent } from './number-cards/number-cards.component';
import { TopicComponent } from './topic/topic.component';
import { TnumberCardsComponent } from './number-cards/tnumber-cards.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { NumberCardsReduceBucketComponent } from './number-cards-reduce-bucket/number-cards-reduce-bucket.component';
import {TNumberCardsReduceBucketComponent } from './t-number-cards-reduce-bucket/t-number-cards-reduce-bucket.component';
import { PositionCardComponent } from './position-card/position-card.component';
import { TPositionCardComponent } from './t-position-card/t-position-card.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { AddCardRepresentationComponent } from './add-card-representation/add-card-representation.component';
import { TAddCardRepresentationComponent } from './t-add-card-representation/t-add-card-representation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { DiscoverComponent } from './discover/discover.component';
import { TExamComponent } from './t-exam/t-exam.component';
import {TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { PlaygroundComponent } from './playground/playground.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';


const dataRepresentationRoutes: Routes = [
  { path: 'dataRepresentation', component:TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'numberCards/:id', component: NumberCardsComponent}, 
      { path: 'cardRepresentationReduce/:id', component: NumberCardsReduceBucketComponent},
      { path: 'positionRepresentation/:id', component: PositionCardComponent},
      { path: 'cardRepresentationAddition/:id', component: AddCardRepresentationComponent},
      { path: 'discover/:id', component: DiscoverComponent},
      { path: 'playground', component: PlaygroundComponent},
      { path: 'exam/:id', component: ExamComponent},
      { path: 'exam/:id/evaluation', component: EvaluationComponent},
      { path: 'exam/:examid/positionRepresentation/:id', component : PositionCardComponent},
      { path: 'exam/:examid/cardRepresentationReduce/:id', component : NumberCardsReduceBucketComponent},
      { path: 'exam/:examid/numberCards/:id', component: NumberCardsComponent}, 
      { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'exam/:examid/discover/:id', component: DiscoverComponent}, 
      { path: 'exam/:examid/cardRepresentationAddition/:id', component: AddCardRepresentationComponent},
      { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent},
      { path: 'openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: MultipleChoiceComponent},

    ] },
    {path: 'teacher/dataRepresentation', canActivate: [TeacherGuard], canActivateChild:[TeacherGuard], component: TopicComponent,
      children:[
      { path: '', component: TExercisesComponent, pathMatch: 'full'},
      { path: 'numberCards/:id', component: TnumberCardsComponent},
      { path: 'numberCards', component: TnumberCardsComponent},
      { path: 'cardRepresentationReduce', component: TNumberCardsReduceBucketComponent},
      { path: 'cardRepresentationReduce/:id', component: TNumberCardsReduceBucketComponent},
      { path: 'positionRepresentation', component: TPositionCardComponent},
      { path: 'positionRepresentation/:id', component: TPositionCardComponent},
      { path: 'cardRepresentationAddition', component: TAddCardRepresentationComponent},
      { path: 'cardRepresentationAddition/:id', component: TAddCardRepresentationComponent},
      { path: 'openQuestion', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice', component: TMultipleChoiceComponent},
      { path: 'openQuestion/:id', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: TMultipleChoiceComponent},
      { path: 'discover/:id', component: TDiscoverComponent},
      { path: 'discover', component: TDiscoverComponent},
      { path: 'allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'allExamsTeacher', component: TAllExamsComponent},
      { path: 'exam', component: TExamComponent},
      { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full'},
        { path: 'exam/:examid/numberCards/:id', component: TnumberCardsComponent},
        { path: 'exam/:examid/numberCards', component: TnumberCardsComponent},
        { path: 'exam/:examid/cardRepresentationReduce', component: TNumberCardsReduceBucketComponent},
        { path: 'exam/:examid/cardRepresentationReduce/:id', component: TNumberCardsReduceBucketComponent},
        { path: 'exam/:examid/positionRepresentation', component: TPositionCardComponent},
        { path: 'exam/:examid/positionRepresentation/:id', component: TPositionCardComponent},
        { path: 'exam/:examid/cardRepresentationAddition', component: TAddCardRepresentationComponent},
        { path: 'exam/:examid/cardRepresentationAddition/:id', component: TAddCardRepresentationComponent},
        { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent},
        { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent},
        { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent},
        { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent},
        { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent},
        { path: 'exam/:examid/discover/:id', component: TDiscoverComponent},
        { path: 'exam/:examid/discover', component: TDiscoverComponent}
    ] }
];

@NgModule({
  imports: [
      RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
